import axios from "axios";

export const modalInfoHandlers = () => {
    $('.cookie__inner > button').click(function () {
        window.localStorage.setItem('cookieIsOk', true);
        $('.cookie').hide();
    });

    if (window.localStorage.getItem('cookieIsOk') !== null) {
        $('#wrapper > .cookie').remove();
    } else {
        $('#wrapper > .cookie').show();
    }

    $('#cookieModalInfo').click(function () {
        cookieModalInfoHandler($(this))
    });

    $('#signUpModalInfo, #recoverPasswordModalInfo').click(function () {
        $(this).parents('.modal-info').hide();
    });
};

const cookieModalInfoHandler = (element) => {
    axios.post(element.data('url'), {})
        .then((response) => {
            element.parents('.modal-info').hide();
        });
};
